/**
 * @fileoverview NoteVisit data source and type definitions.
 * Immutable event log for tracking note access and visits.
 */

import { NoteVisitSchema, type NoteVisit } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createCreatedAtField, createDateTimeField, createIdField, createJsonField, createSelectField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';
import { createOptionLoader } from './option-loader';

export type { NoteVisit };

const noteLoader = createOptionLoader('note', 'title', 'id');
const accountLoader = createOptionLoader('account', 'display_name', 'id');

export const noteVisitDataSource = createBaseDataSource<NoteVisit>({
  endpoint: 'note_visit',
  searchField: 'note_id',
  schema: NoteVisitSchema,
  fields: [
    createIdField(),
    createSelectField('note_id', 'Note', noteLoader.getOptions(), FIELD_WIDTHS.MEDIUM),
    createSelectField('account_id', 'Account', accountLoader.getOptions(), FIELD_WIDTHS.MEDIUM),
    createDateTimeField('visited_at', 'Visited At', FIELD_TYPE_WIDTHS.DATE),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.MEDIUM),
    createCreatedAtField(),
  ],
});

export const noteVisitCache = getCache('note_visit');
